// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          white: '#000000',
          midnight: '#333333',
          primaryRed: '#dc0028',
          secondaryRed: '#89031b',
          grey1: '#f9fafb',
          grey2: '#e7e9ee',
          grey3: '#9da3ae',
          grey4: '#606a76',
          grey5: '#3c424c',
          focused: '#5971f2',
          alpha60: 'rgba(51, 51, 51, 0.6)',
        }
      },
    },
  },
}
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
)
